(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-bedding-real-life"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCard(card) {
    if (card.dataset.rlInit === '1') return;
    var video = card.querySelector('video');
    if (!video) return;
    card.dataset.rlInit = '1';

    var muteBtn = card.querySelector('[data-rl-mute]');
    if (muteBtn) {
      muteBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        video.muted = !video.muted;
        muteBtn.innerHTML = video.muted ? '🔇' : '🔊';
        if (!video.muted && video.paused) { video.play(); }
      });
    }
  }

  function initQuickBuy(btn) {
    if (btn.dataset.rlBuyInit === '1') return;
    btn.dataset.rlBuyInit = '1';
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var variantId = btn.getAttribute('data-rl-buy');
      if (!variantId) return;
      var original = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      }).then(function () {
        btn.textContent = '✓ Added';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:open'));
        var drawer = document.querySelector('cart-drawer, #cart-drawer, [data-cart-drawer]');
        if (drawer && typeof drawer.open === 'function') drawer.open();
        else if (drawer && drawer.classList) drawer.classList.add('is-open', 'active', 'open');
        setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1500);
      }).catch(function (err) {
        btn.textContent = (err && err.description) || 'Error';
        setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 2400);
      });
    });
  }

  function boot(scope) {
    var root = scope || document;

    // Video kartlar
    var cards = root.querySelectorAll('.rl__card--video');
    cards.forEach(initCard);
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target.querySelector('video');
          if (!v) return;
          if (entry.isIntersecting) {
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            v.pause();
          }
        });
      }, { threshold: 0.25 });
      cards.forEach(function (c) { io.observe(c); });
    }

    // Quick Buy butonları
    root.querySelectorAll('[data-rl-buy]').forEach(initQuickBuy);
  }

  boot();

  // Mobilde ilk dokunuşta otomatik oynatmayı zorla
  document.addEventListener('touchstart', function () {
    document.querySelectorAll('.rl__card--video video').forEach(function (v) {
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    });
  }, { once: true });

  // Tema editöründe bölüm yeniden yüklenince tekrar başlat
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-gallery-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  var roots = document.querySelectorAll('[data-gg-root]');
  if (!roots.length) return;

  function formatMoneyCents(cents, template) {
    cents = Math.round(cents);
    var amount = (cents / 100).toFixed(2);
    if (!template) return '$' + amount;
    return template
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(cents / 100)))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','));
  }
  var moneyTemplate = (window.Shopify && window.Shopify.money_format) || '${{amount}}';

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function renderStars(rating) {
    var r = Number(rating) || 0;
    var full = Math.round(r);
    var s = '';
    for (var i = 0; i < 5; i++) s += i < full ? '★' : '☆';
    return s;
  }

  function clampTooltip(btn) {
    var tip = btn.querySelector('.gg__hotspot-tip');
    if (!tip) return;
    var media = btn.closest('.gg__media');
    if (!media) return;

    tip.style.setProperty('--gg-shift-x', '0px');
    tip.classList.remove('is-below');

    var prevDisplay = tip.style.display;
    var prevVis = tip.style.visibility;
    if (window.getComputedStyle(tip).display === 'none') {
      tip.style.visibility = 'hidden';
      tip.style.display = 'inline-flex';
    }

    var m = media.getBoundingClientRect();
    var b = btn.getBoundingClientRect();
    var t = tip.getBoundingClientRect();

    var btnCx = b.left + b.width / 2;
    var halfW = t.width / 2;
    var pad = 8;
    var defaultLeft  = btnCx - halfW;
    var defaultRight = btnCx + halfW;
    var leftBound  = m.left  + pad;
    var rightBound = m.right - pad;

    var shiftX = 0;
    if (defaultLeft < leftBound)        shiftX = leftBound - defaultLeft;
    else if (defaultRight > rightBound) shiftX = rightBound - defaultRight;
    tip.style.setProperty('--gg-shift-x', shiftX + 'px');

    // Yukarıda yer kalmadıysa altına al
    if (b.top - t.height - 12 < m.top + pad) {
      tip.classList.add('is-below');
    }

    tip.style.display = prevDisplay;
    tip.style.visibility = prevVis;
  }

  roots.forEach(function (root) {
    var modal = root.querySelector('[data-gg-modal]');
    var moreBtn = root.querySelector('[data-gg-more]');

    var hotspots = root.querySelectorAll('.gg__hotspot');

    function deactivateAllHotspots() {
      hotspots.forEach(function (h) {
        h.classList.remove('is-active');
        h.setAttribute('aria-expanded', 'false');
      });
    }

    hotspots.forEach(function (btn) {
      // Desktop hover/focus → konumlandır (mobilde hover yok)
      var positionHandler = function () { clampTooltip(btn); };
      btn.addEventListener('mouseenter', positionHandler);
      btn.addEventListener('focusin', positionHandler);

      // Tıklama: Shop The Look aksiyonu mu yoksa dot mu?
      btn.addEventListener('click', function (e) {
        // Shop The Look (tip-action) tıklandı → root handler modal'ı açacak; sadece hotspot'u kapat
        if (e.target.closest('[data-gg-open]')) {
          deactivateAllHotspots();
          return; // stopPropagation YOK — root'un [data-gg-open] handler'ı modal'ı açsın
        }
        // Dot tıklandı → toggle (accordion: önce hepsini kapat, sonra bunu aç)
        e.preventDefault();
        e.stopPropagation();
        var willOpen = !btn.classList.contains('is-active');
        deactivateAllHotspots();
        if (willOpen) {
          btn.classList.add('is-active');
          btn.setAttribute('aria-expanded', 'true');
          clampTooltip(btn);
        }
      });
    });

    // Dışarı tıklayınca açık tooltip kapansın
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.gg__hotspot')) {
        deactivateAllHotspots();
      }
    });

    // Resize → açık tooltip varsa yeniden konumla
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var active = root.querySelector('.gg__hotspot.is-active');
        if (active) clampTooltip(active);
      }, 120);
    });

    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        // Bölüm-içi: gizli ürünleri aç (root zaten .gg sınıfını taşıyor)
        root.classList.add('is-m-expanded');
        // Çoklu bölüm: gizlenmiş tüm Gallery Grid'leri aç
        document.querySelectorAll('.gg--mcollapse').forEach(function (el) { el.classList.add('is-revealed'); });
        // Tüm View more butonlarını gizle
        document.querySelectorAll('[data-gg-more]').forEach(function (b) { b.classList.add('is-hidden'); });
      });
    }

    if (!modal) return;
    var modalTitle = modal.querySelector('[data-gg-modal-title]');
    var modalDesc = modal.querySelector('[data-gg-modal-desc]');
    var modalItems = modal.querySelector('[data-gg-modal-items]');
    var modalAdd = modal.querySelector('[data-gg-add]');
    var modalClose = modal.querySelector('[data-gg-close]');
    var currentLook = null;
    var quantities = {};
    var addLabelTemplate = (modalAdd && modalAdd.textContent.trim()) || 'Add all [count] for [total]';

    function openModal(blockId) {
      var dataEl = root.querySelector('script[data-gg-look-data="' + blockId + '"]');
      if (!dataEl) return;
      var data;
      try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
      if (!data || !data.products || !data.products.length) return;

      currentLook = data;
      quantities = {};
      data.products.forEach(function (p) { quantities[p.variantId] = 1; });

      modalTitle.textContent = data.title || '';
      if (data.description) {
        modalDesc.textContent = data.description;
        modalDesc.style.display = '';
      } else {
        modalDesc.textContent = '';
        modalDesc.style.display = 'none';
      }
      renderItems();
      updateAddButton();
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      currentLook = null;
    }

    function renderItems() {
      if (!currentLook) return;
      var html = '';
      currentLook.products.forEach(function (p) {
        var qty = quantities[p.variantId] || 1;
        var compareHtml = p.comparePriceFormatted ? '<span class="gg__modal-compare">' + p.comparePriceFormatted + '</span>' : '';
        var imgHtml = p.image ? '<img src="' + p.image + '" alt="">' : '';
        html += '' +
          '<div class="gg__modal-item" data-row="' + p.variantId + '">' +
            imgHtml +
            '<div class="gg__modal-item-info">' +
              '<div class="gg__modal-item-title">' + escapeHtml(p.title) + '</div>' +
              '<div class="gg__modal-rating"><span class="gg__modal-rating-stars">' + renderStars(p.rating) + '</span> ' + (Number(p.rating).toFixed(1)) + '</div>' +
              '<div class="gg__modal-price"><span>' + p.priceFormatted + '</span>' + compareHtml + '</div>' +
            '</div>' +
            '<div class="gg__modal-qty">' +
              '<button type="button" data-dec aria-label="Decrease">−</button>' +
              '<input type="number" min="0" value="' + qty + '" data-qty>' +
              '<button type="button" data-inc aria-label="Increase">+</button>' +
            '</div>' +
          '</div>';
      });
      modalItems.innerHTML = html;
      modalItems.querySelectorAll('[data-row]').forEach(function (row) {
        var vId = row.getAttribute('data-row');
        var inp = row.querySelector('[data-qty]');
        row.querySelector('[data-dec]').addEventListener('click', function () {
          var v = Math.max(0, (parseInt(inp.value, 10) || 0) - 1);
          inp.value = v; quantities[vId] = v; updateAddButton();
        });
        row.querySelector('[data-inc]').addEventListener('click', function () {
          var v = Math.max(0, (parseInt(inp.value, 10) || 0) + 1);
          inp.value = v; quantities[vId] = v; updateAddButton();
        });
        inp.addEventListener('input', function () {
          var v = Math.max(0, parseInt(inp.value, 10) || 0);
          quantities[vId] = v; updateAddButton();
        });
      });
    }

    function totalCents() {
      if (!currentLook) return 0;
      var t = 0;
      currentLook.products.forEach(function (p) {
        t += (Number(p.price) || 0) * (quantities[p.variantId] || 0);
      });
      return t;
    }
    function totalCount() {
      var n = 0;
      Object.keys(quantities).forEach(function (k) { n += quantities[k] || 0; });
      return n;
    }
    function updateAddButton() {
      if (!modalAdd) return;
      var count = totalCount();
      var totalStr = formatMoneyCents(totalCents(), moneyTemplate);
      modalAdd.textContent = addLabelTemplate.replace('[count]', count).replace('[total]', totalStr);
      modalAdd.disabled = count === 0;
    }

    root.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-gg-open]');
      if (!trigger) return;
      e.preventDefault();
      openModal(trigger.getAttribute('data-gg-open'));
    });
    if (modalClose) modalClose.addEventListener('click', closeModal);
    modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });

    if (modalAdd) {
      modalAdd.addEventListener('click', function () {
        if (!currentLook) return;
        var items = [];
        currentLook.products.forEach(function (p) {
          var q = quantities[p.variantId] || 0;
          if (q > 0 && p.variantId) items.push({ id: p.variantId, quantity: q });
        });
        if (!items.length) return;
        modalAdd.disabled = true;
        var original = modalAdd.textContent;
        modalAdd.textContent = 'Adding…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) {
          if (!r.ok) return r.json().then(function (err) { throw err; });
          return r.json();
        }).then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:open'));
          var drawer = document.querySelector('cart-drawer, #cart-drawer, [data-cart-drawer]');
          if (drawer && typeof drawer.open === 'function') drawer.open();
          else if (drawer && drawer.classList) drawer.classList.add('is-open', 'active', 'open');
          else window.location.href = '/cart';
          closeModal();
        }).catch(function (err) {
          modalAdd.textContent = (err && err.description) || 'Could not add — try again';
          setTimeout(function () { modalAdd.textContent = original; modalAdd.disabled = false; }, 2400);
        });
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
